import {
  NameSpecifiedEntity
} from "../entity";
import {
  Sex,
  Age
} from ".";

export class Patient extends NameSpecifiedEntity<string> {
  constructor(id: string, name: string, public kanaName: string, public birthday: Date, public sex: Sex) {
    super(id, name);
  }

  get age(): Age {
    return Age.calculate(this.birthday);
  }
}
